export default __webpack_public_path__ + "static/media/qr_code.9785367d.svg";